import { useMemo } from 'react';

interface PlatformCardColors {
	title: string;
	parentBgColorClass: string;
	childBgColorClass: string;
	label: string;
	borderColorClass: string;
	checkedColorClass: string;
}

function usePlatformCardColors(platform: string): PlatformCardColors {
	const platformCardColors = useMemo(() => {
		let title = platform;
		let parentBgColorClass = 'to-grey-500';
		let borderColorClass = 'border-grey-500';
		let checkedColorClass = '';
		let childBgColorClass = '';
		let label = '';

		switch (platform) {
			case 'telegram':
				title = 'telegram';
				parentBgColorClass = 'to-primary-main';
				childBgColorClass = 'bg-primary-selected';
				borderColorClass = 'border-primary-main';
				checkedColorClass = 'text-primary-main';
				label = 'group_and_channel';
				break;
			case 'instagram':
				title = 'instagram';
				parentBgColorClass = 'to-secondary-main';
				childBgColorClass = 'bg-secondary-selected';
				borderColorClass = 'border-secondary-main';
				checkedColorClass = 'text-secondary-main';
				label = 'page';
				break;
			case 'rubika':
				title = 'rubika';
				parentBgColorClass = 'to-green-200';
				childBgColorClass = 'bg-green-selected';
				borderColorClass = 'border-green-200';
				checkedColorClass = 'text-green-main';
				label = 'group_and_channel';
				break;
			case 'eita':
				title = 'eita';
				parentBgColorClass = 'to-orange-600';
				childBgColorClass = 'bg-orange-selected';
				borderColorClass = 'border-orange-600';
				checkedColorClass = 'text-orange-main';
				label = 'group_and_channel';
				break;
			case 'soroush':
				title = 'soroush';
				parentBgColorClass = 'to-primary-main';
				childBgColorClass = 'bg-primary-selected';
				borderColorClass = 'border-primary-main';
				checkedColorClass = 'text-primary-main';
				label = 'group_and_channel';
				break;
			case 'bale':
				title = 'bale';
				parentBgColorClass = 'to-green-200';
				childBgColorClass = 'bg-green-selected';
				borderColorClass = 'border-green-200';
				checkedColorClass = 'text-green-main';
				label = 'group_and_channel';
				break;
			case 'influenceral':
				title = 'influenceral';
				parentBgColorClass = 'to-primary-main';
				childBgColorClass = 'bg-primary-selected';
				borderColorClass = 'border-primary-main';
				checkedColorClass = 'text-primary-main';
				label = 'group_and_channel';
				break;
			case 'app':
				title = 'app';
				parentBgColorClass = 'to-green-700';
				childBgColorClass = 'bg-green-selected';
				borderColorClass = 'border-green-200';
				checkedColorClass = 'text-green-main';
				label = 'app';
				break;
			case 'sms':
				title = 'sms_panel';
				parentBgColorClass = 'to-primary-main';
				childBgColorClass = 'bg-primary-selected';
				borderColorClass = 'border-primary-main';
				checkedColorClass = 'text-primary-main';
				label = 'panel';
				break;
			case 'media_growth':
				title = 'media_growth';
				parentBgColorClass = 'to-orange-600';
				childBgColorClass = 'bg-orange-selected';
				borderColorClass = 'border-orange-600';
				checkedColorClass = 'text-orange-main';
				label = 'channel_and_page';
				break;
			case 'website_ad':
				title = 'website_ad';
				parentBgColorClass = 'to-secondary-main';
				childBgColorClass = 'bg-secondary-selected';
				borderColorClass = 'border-secondary-main';
				checkedColorClass = 'text-secondary-main';
				label = 'website';
				break;
			default:
				title = platform;
				parentBgColorClass = 'to-grey-500';
				childBgColorClass = '';
				borderColorClass = '';
				checkedColorClass = '';
				label = '';
		}

		return {
			title,
			parentBgColorClass,
			childBgColorClass,
			borderColorClass,
			checkedColorClass,
			label,
		};
	}, [platform]);

	return platformCardColors;
}

export default usePlatformCardColors;
